import ApiService from "./api.service";

const PREFIX = 'extra-cost';

const ExtraCost = {
	createOrUpdate: (data,header) => {
		return ApiService.post(`${PREFIX}/add/${header.docId}/${header.method}/READY`, data);
	},
	createOrUpdateSuspended: (data,header) => {
		return ApiService.post(`${PREFIX}/add/${header.docId}/${header.method}/SUSPENDED`, data);
	},

	loadByDocument: (id) => {
		return ApiService.get(`${PREFIX}/list-by-document/${id}`).then(response => {
			if (response.data) {
				return response.data
			}
		})
	}
};

export default ExtraCost;
